import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useState } from "react";
import { sezioneCodiciRUI, useFormIscrizione } from "../FormContext";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { apiComuni } from "../utils/registerAPI";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Persona = ({ province, toponomie, errors }) => {
  const { formState, dispatch } = useFormIscrizione();
  const [comuni, setComuni] = useState([]);
  const [cap, setCap] = useState([]);

  const handleComuni = (provinciaSigla) => {
    apiComuni(provinciaSigla).then((response) => setComuni(response.data[0]));
  };

  const handleCap = (comuneCodice) => {
    comuni.map((el) => {
      if (el.codice === comuneCodice) {
        setCap(el.cap);
        if (el.cap.length === 1) {
          dispatch({
            type: "set_datiResponsabile",
            payload: {
              cap: el.cap[0],
            },
          });
        }
      }
    });
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Box>
          <Typography component="h1" variant="h6" gutterBottom mb={4}>
            Dati Anagrafici
          </Typography>
          <Grid container spacing={3} wrap="wrap">
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Cognome"
                fullWidth
                value={formState.datiResponsabile.cognome}
                id="cognome-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      cognome: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.cognome)}
                helperText={errors.datiResponsabile.cognome}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Nome"
                fullWidth
                value={formState.datiResponsabile.nome}
                id="nome-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      nome: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.nome)}
                helperText={errors.datiResponsabile.nome}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="CF"
                fullWidth
                value={formState.datiResponsabile.cf}
                id="cf-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      cf: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.cf)}
                helperText={errors.datiResponsabile.cf}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <Autocomplete
                size="small"
                fullWidth
                options={province}
                getOptionLabel={(option) => option.nome}
                value={
                  province.find(
                    (p) => p.sigla === formState.datiResponsabile.provincia
                  ) || null
                }
                onChange={(_, newValue) => {
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      provincia: newValue ? newValue.sigla : "",
                      comune: "",
                      cap: "",
                    },
                  });
                  if (newValue) handleComuni(newValue.sigla, "responsabile");
                }}
                renderInput={(params) => (
                  <TextField
                    id="provinciaResponsabile"
                    name="provinciaResponsabile"
                    error={Boolean(errors.datiResponsabile.provincia)}
                    helperText={errors.datiResponsabile.provincia}
                    {...params}
                    label="Provincia"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <Autocomplete
                size="small"
                fullWidth
                options={comuni}
                getOptionLabel={(option) => option.comune}
                value={
                  comuni.find(
                    (c) => c.codice === formState.datiResponsabile.comune
                  ) || null
                }
                onChange={(_, newValue) => {
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      comune: newValue ? newValue.codice : "",
                      cap: "",
                    },
                  });
                  if (newValue) handleCap(newValue.codice, "responsabile");
                }}
                renderInput={(params) => (
                  <TextField
                    id="comuneResponsabile"
                    name="comuneResponsabile"
                    error={Boolean(errors.datiResponsabile.comune)}
                    helperText={errors.datiResponsabile.comune}
                    {...params}
                    label="Comune"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <FormControl
                size="small"
                fullWidth
                margin="none"
                required
                error={Boolean(errors.datiResponsabile.cap)}
              >
                <InputLabel id="capResponsabile-label">CAP</InputLabel>
                <Select
                  labelId="capResponsabile-label"
                  id="capResponsabile"
                  name="capResponsabile"
                  label="CAP"
                  value={formState.datiResponsabile.cap}
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    dispatch({
                      type: "set_datiResponsabile",
                      payload: {
                        cap: e.target.value,
                      },
                    });
                  }}
                >
                  {cap.map((el, i) => (
                    <MenuItem key={i} value={el}>
                      {el}
                    </MenuItem>
                  ))}
                </Select>
                {errors.datiResponsabile.cap && (
                  <FormHelperText>{errors.datiResponsabile.cap}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item sm={3} xs={12}>
              <Autocomplete
                size="small"
                fullWidth
                options={toponomie}
                getOptionLabel={(option) => option.name}
                value={
                  toponomie.find(
                    (t) => t.value === formState.datiResponsabile.viacorso
                  ) || null
                }
                onChange={(_, newValue) => {
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      viacorso: newValue ? newValue.value : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(errors.datiResponsabile.viacorso)}
                    helperText={errors.datiResponsabile.viacorso}
                    label="Via, Corso"
                    required
                  />
                )}
              />
            </Grid>

            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Indirizzo"
                fullWidth
                value={formState.datiResponsabile.indirizzo}
                id="indirizzo-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      indirizzo: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.indirizzo)}
                helperText={errors.datiResponsabile.indirizzo}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Civico"
                fullWidth
                value={formState.datiResponsabile.civico}
                id="civico-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      civico: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.civico)}
                helperText={errors.datiResponsabile.civico}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Cellulare"
                fullWidth
                value={formState.datiResponsabile.cellulare}
                id="cellulare-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      cellulare: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.cellulare)}
                helperText={errors.datiResponsabile.cellulare}
              />
            </Grid>
            {/* <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="E-mail"
                fullWidth
                value={formState.datiResponsabile.email}
                id="email-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_datiResponsabile",
                    payload: {
                      email: e.target.value,
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.email)}
                helperText={errors.datiResponsabile.email}
              />
            </Grid> */}
          </Grid>
        </Box>
        <Box mt={8}>
          <Typography component="h1" variant="h6" gutterBottom mb={4}>
            Ivass RUI
          </Typography>
          <Grid container spacing={3} wrap="wrap">
            <Grid item sm={3} xs={12}>
              <FormControl
                size="small"
                fullWidth
                margin="none"
                required
                error={Boolean(errors.datiResponsabile.sezioneRUI)}
              >
                <InputLabel id="sezioneRUI-label">
                  Sezione Codice RUI
                </InputLabel>
                <Select
                  labelId="sezioneRUI-label"
                  id="sezioneRUI"
                  name="sezioneRUI"
                  label="Sezione Codice RUI"
                  value={formState.datiResponsabile.ivassRUI.sezioneRUI}
                  MenuProps={MenuProps}
                  onChange={(e) => {
                    dispatch({
                      type: "set_ivassRUI",
                      payload: {
                        section: "datiResponsabile",
                        data: { sezioneRUI: e.target.value },
                      },
                    });
                  }}
                >
                  {sezioneCodiciRUI.map((el) => (
                    <MenuItem key={el.value} value={el.value}>
                      {el.label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.datiResponsabile.sezioneRUI && (
                  <FormHelperText>
                    {errors.datiResponsabile.sezioneRUI}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item sm={3} xs={12}>
              <TextField
                size="small"
                margin="none"
                label="Codice RUI"
                fullWidth
                value={formState.datiResponsabile.ivassRUI.codiceRUI}
                id="codiceRUI-persona"
                onChange={(e) =>
                  dispatch({
                    type: "set_ivassRUI",
                    payload: {
                      section: "datiResponsabile",
                      data: { codiceRUI: e.target.value },
                    },
                  })
                }
                required
                error={Boolean(errors.datiResponsabile.codiceRUI)}
                helperText={errors.datiResponsabile.codiceRUI}
              />
            </Grid>
            <Grid item sm={3} xs={12}>
              <FormControl fullWidth>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  renderInput={(props) => (
                    <TextField
                      {...props}
                      error={Boolean(errors.datiResponsabile.dataIscrizioneRUI)}
                      helperText={errors.datiResponsabile.dataIscrizioneRUI}
                      required
                    />
                  )}
                  label="Data Iscrizione "
                  name="Data_Iscrizione"
                  id="DataIscrizioneRUI-persona"
                  value={
                    formState.datiResponsabile.ivassRUI.dataIscrizioneRUI === ""
                      ? null
                      : dayjs(
                          formState.datiResponsabile.ivassRUI.dataIscrizioneRUI,
                          "DD/MM/YYYY"
                        )
                          .utc()
                          .toISOString()
                  }
                  onChange={(e) => {
                    const value = dayjs(e).format("DD/MM/YYYY");
                    dispatch({
                      type: "set_ivassRUI",
                      payload: {
                        section: "datiResponsabile",
                        data: { dataIscrizioneRUI: value },
                      },
                    });
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Persona;
